module.exports = __webpack_public_path__ + "/images/cover-fr-hero@2x.9eceb82.png";